import styles from './BgVideoLines.module.css';

import bgVideo from '../../../assets/video/bgVideoLines.webm';
import bgPoster from '../../../assets/images/bgPosterLines.webp';

export const BgVideoLines = () => {
  return (
    <div className={styles.bgVideoWrapper}>
      <video playsInline muted="muted" loop poster={bgPoster} autoPlay={true}>
        <source src={bgVideo} type="video/webm" />
      </video>
    </div>
  );
};
